import { render, staticRenderFns } from "./DocumentObjectEdit.vue?vue&type=template&id=5cc3195e&"
import script from "./DocumentObjectEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentObjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports